var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-slider',{attrs:{"label":_vm.label,"min":_vm.min,"max":_vm.max,"step":_vm.step,"readonly":!_vm.enabled},model:{value:(_vm.innerValue),callback:function ($$v) {_vm.innerValue=$$v},expression:"innerValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }